/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  startNow(id) {
    return axios.post(`${this.url}/${id}/start_now`);
  }

  getMessages(
    id,
    page,
    status,
    error = null,
    contactFilters = {},
    options = {}
  ) {
    return axios.get(`${this.url}/${id}/messages`, {
      params: { page, status, error, ...contactFilters },
      signal: options.signal,
    });
  }

  getRecipientStats(id) {
    return axios.get(`${this.url}/${id}/recipient_stats`);
  }

  removeRecipients(id, contactIds) {
    return axios.post(`${this.url}/${id}/remove_recipients`, {
      contact_ids: contactIds,
    });
  }

  schedule(id, data) {
    return axios.post(`${this.url}/${id}/schedule`, data);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new CampaignsAPI();
